/**
 * TimeZones constant for user registration default timezone settings
 * Used in RegisterSummary.tsx for setting notificationTimeZone
 */

export interface TimeZone {
  label: string;
  value: string;
}

export const TimeZones: TimeZone[] = [
  { label: 'Eastern Time (ET)', value: 'America/New_York' },
  { label: 'Central Time (CT)', value: 'America/Chicago' },
  { label: 'Mountain Time (MT)', value: 'America/Denver' },
  { label: 'Pacific Time (PT)', value: 'America/Los_Angeles' },
  { label: 'Alaska Time (AKT)', value: 'America/Anchorage' },
  { label: 'Hawaii Time (HST)', value: 'Pacific/Honolulu' },
  { label: 'Atlantic Time (AT)', value: 'America/Halifax' },
  { label: 'Newfoundland Time (NT)', value: 'America/St_Johns' },
  { label: 'UTC', value: 'UTC' },
  { label: 'Greenwich Mean Time (GMT)', value: 'Europe/London' },
  { label: 'Central European Time (CET)', value: 'Europe/Paris' },
  { label: 'Eastern European Time (EET)', value: 'Europe/Helsinki' },
  { label: 'Moscow Time (MSK)', value: 'Europe/Moscow' },
  { label: 'India Standard Time (IST)', value: 'Asia/Kolkata' },
  { label: 'China Standard Time (CST)', value: 'Asia/Shanghai' },
  { label: 'Japan Standard Time (JST)', value: 'Asia/Tokyo' },
  { label: 'Australian Eastern Time (AET)', value: 'Australia/Sydney' },
  { label: 'Australian Central Time (ACT)', value: 'Australia/Adelaide' },
  { label: 'Australian Western Time (AWT)', value: 'Australia/Perth' },
];

export default TimeZones;